import React from 'react';
import {
  Box,
  Flex,
  Icon,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { X } from 'phosphor-react';
import { Facet } from './facet';
import { FacetOptionList } from './FacetOptionList';

interface FacetChipProps {
  facet: Facet;
}

export const FacetChip = ({ facet }: FacetChipProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const selected = facet.options.filter((option) => facet.values.includes(option.value));
  if (selected.length === 0) return null;

  const operator = selected.length === 1 ? 'é' : 'é um de';

  return (
    <Flex
      h="34px"
      align="center"
      maxW="100%"
      bg="surface.canvas"
      border="1px solid"
      borderColor="line.hairline"
      borderRadius="lg"
      overflow="hidden"
    >
      <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose} placement="bottom-start">
        <PopoverTrigger>
          <Flex
            as="button"
            type="button"
            h="full"
            align="center"
            gap="6px"
            pl="13px"
            pr="10px"
            minW={0}
            cursor="pointer"
            fontSize="13px"
            _hover={{ bg: 'surface.selected' }}
            aria-label={`Opções do filtro ${facet.label}`}
          >
            <Icon as={facet.icon} w="14px" h="14px" color="content.strong" flexShrink={0} />
            <Text as="span" fontWeight={500} color="content.strong" whiteSpace="nowrap">
              {facet.label}
            </Text>
            <Text as="span" color="content.subtle" whiteSpace="nowrap">
              {operator}
            </Text>
            <Text as="span" color="content.strong" noOfLines={1} maxW="220px">
              {selected.map((option) => option.label).join(', ')}
            </Text>
          </Flex>
        </PopoverTrigger>
        <PopoverContent w="288px" p={0} overflow="hidden">
          <PopoverBody p={0}>
            <FacetOptionList
              facet={facet}
              onApply={(values) => {
                facet.apply(values);
                if (!facet.multiple) onClose();
              }}
            />
          </PopoverBody>
        </PopoverContent>
      </Popover>

      <Box w="1px" h="full" bg="line.hairline" flexShrink={0} />

      <Flex
        as="button"
        type="button"
        w="30px"
        h="full"
        align="center"
        justify="center"
        flexShrink={0}
        cursor="pointer"
        color="content.subtle"
        _hover={{ bg: 'surface.selected', color: 'content.strong' }}
        aria-label={`Remover filtro ${facet.label}`}
        onClick={() => facet.apply([])}
      >
        <X size={12} />
      </Flex>
    </Flex>
  );
};
